import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import StarRating from "./starrating";
import { Button } from "src/components/shadcn/button";
import { Input } from "../../shadcn/input";

export default function TabelFeedbackCustomer({ tombol, jumlahdata }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [feedbackSearchQuery, setFeedbackSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const roleId = parseInt(localStorage.getItem("roleId"), 10);
  const kitchenId = parseInt(localStorage.getItem("kitchenId"), 10);
  const locationId = localStorage.getItem("locationId");
  const itemsPerPage = jumlahdata;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const url = kitchenId
          ? `/customers_result/kitchen/${kitchenId}`
          : `/customers_result/location/${locationId}`;
        const response = await instance2.get(url);
              const filteredData = response.data.filter(item => item.received_qty != null);

      setData(filteredData);
      //  setData(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [kitchenId, locationId]);

  // Memoized filtered and sorted data
  const filteredSortedData = useMemo(() => {
    const search = feedbackSearchQuery.toLowerCase();
    const filtered = data.filter((item) => {
      const formattedDate = new Date(item.date)
        .toLocaleDateString("id-ID", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        })
        .toLowerCase();
      return (
        formattedDate.includes(search) ||
        (item.customer_name ?? "").toLowerCase().includes(search)||
        (item.kitchen_name ?? "").toLowerCase().includes(search)||
        (item.delivery ?? "").toLowerCase().includes(search)
      );
    });

    if (!sortConfig.key) return filtered;

    const getAvg = (item) => {
      const parse = (v) => (v != null ? parseFloat(v).toFixed(1) : 0);
      const qty = Number(parse(item.rate_qty));
      const time = Number(parse(item.rate_time));
      const quality = Number(parse(item.rate_quality));
      return (qty + time + quality) / 3;
    };

    return [...filtered].sort((a, b) => {
      const aValue =
        sortConfig.key === "average_rating"
          ? getAvg(a)
          : a[sortConfig.key] ?? "";
      const bValue =
        sortConfig.key === "average_rating"
          ? getAvg(b)
          : b[sortConfig.key] ?? "";
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [data, feedbackSearchQuery, sortConfig]);

  // Pagination
  const totalPages = Math.ceil(filteredSortedData.length / itemsPerPage);
  const paginatedData = useMemo(
    () =>
      filteredSortedData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      ),
    [filteredSortedData, currentPage, itemsPerPage]
  );

  // Pagination page numbers
  const maxVisiblePages = 5;
  let pageNumbers = [];
  if (totalPages <= maxVisiblePages) {
    pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else if (currentPage <= 3) {
    pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
  } else if (currentPage >= totalPages - 2) {
    pageNumbers = [
      1,
      "...",
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];
  } else {
    pageNumbers = [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  }

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getSortArrow = (key) =>
    sortConfig.key === key ? (sortConfig.direction === "asc" ? "▲" : "▼") : "";

  return (
    <div className="p-4">
      <div className="flex flex-col md:flex-col lg:flex-row items-start md:items-start lg:items-center justify-between mb-4">
        <h2 className="text-xl sm:text-2xl font-medium">Feedback Penerima Manfaat</h2>
        {roleId === 3 && tombol && (
          <div className="flex items-center justify-end">
            <Button onClick={() => navigate("/ratingpelanggan")}>
              Ke Halaman Feedback Penerima Manfaat
            </Button>
          </div>
        )}
      </div>

      {loading && (
        <div className="flex justify-center py-8">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      )}
      {error && <div className="text-center text-red-500">{error}</div>}
      {!loading && !error && data.length === 0 && (
        <p className="text-gray-500 text-center sm:text-xs md:text-xs lg:text-base">
          Tidak ada data yang tersedia
        </p>
      )}

      {!loading && !error && data.length > 0 && (
        <div className="overflow-x-auto">
          {tombol ? (
                      <div className="pb-4 flex flex-col overflow-x-auto gap-4">
            <div className="flex items-center relative w-full">
              <Input
                type="text"
                placeholder="Telusuri data"
                value={feedbackSearchQuery}
                onChange={(e) => setFeedbackSearchQuery(e.target.value)}
                className="flex w-full rounded-full p-2 pl-10"
              />
              <div className="flex items-center gap-2 absolute left-2">
                <MagnificationLogo className="size-4" />
                <VerticalLine />
              </div>
            </div>
          </div>) :(<div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
                                      <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
                                        <MagnificationLogo className="w-6 h-6" />
                                        <VerticalLine className="mx-1" />
                                        <input
                                          type="text"
                                          placeholder="Telusuri data berdasarkan nama Penerima Manfaat"
                                          className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                                          style={{
                                            width: `${"Telusuri data berdasarkan nama Penerima Manfaat".length}ch`,
                                          }}
                                          value={feedbackSearchQuery} // Controlled input
                                          onChange={(e) => setFeedbackSearchQuery(e.target.value)} // Update search query
                                        />
                                      </div>
                                      </div>)}

          <table className="table-fixed min-w-full border-collapse">
            <thead className="bg-gray-200">
              <tr className="bg-white">
                <th
                  className="border-b px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer rounded-tl-[15px]"
                  onClick={() => handleSort("date")}
                >
                  Tanggal <span className="float-right">{getSortArrow("date")}</span>
                </th>
                {(roleId === 3 || roleId === 5) && (
                  <th
                    className="border-b px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer"
                    onClick={() => handleSort("customer_name")}
                  >
                    Penerima Manfaat <span className="float-right">{getSortArrow("customer_name")}</span>
                  </th>
                )}
                {roleId === 4 && (
                  <th
                    className="border-b px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer"
                    onClick={() => handleSort("kitchen_name")}
                  >
                    Dapur <span className="float-right">{getSortArrow("kitchen_name")}</span>
                  </th>
                )}
                <th
                  className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base cursor-pointer"
                  onClick={() => handleSort("rate_qty")}
                >
                  Jumlah <span className="float-right">{getSortArrow("rate_qty")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base cursor-pointer"
                  onClick={() => handleSort("rate_time")}
                >
                  Waktu <span className="float-right">{getSortArrow("rate_time")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base cursor-pointer"
                  onClick={() => handleSort("rate_quality")}
                >
                  Kualitas <span className="float-right">{getSortArrow("rate_quality")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base cursor-pointer rounded-tr-[15px]"
                  onClick={() => handleSort("average_rating")}
                >
                  Rata-rata <span className="float-right">{getSortArrow("average_rating")}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => {
                const parse = (v) => (v != null ? parseFloat(v).toFixed(1) : 0);
                const rateQty = Number(parse(item.rate_qty));
                const rateTime = Number(parse(item.rate_time));
                const rateQuality = Number(parse(item.rate_quality));
                const avg = (rateQty + rateTime + rateQuality) / 3;

                return (
                  <tr
                    key={item.id}
                    className={index % 2 === 0 ? "bg-transparent" : "bg-gray-50"}
                  >
                    <td className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base">
                      {new Date(item.date).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      })}
                    </td>
                    {(roleId === 3  || roleId === 5)&& (
                      <td className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base">
                        {item.customer_name} ({item.delivery})
                      </td>
                    )}
                    {roleId === 4 && (
                      <td className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base">
                        {item.kitchen_name}
                      </td>
                    )}
                    {avg === 0 ? (
                      <td
                        colSpan={4}
                        className="border-b px-4 py-2 text-center italic text-gray-500 text-xxs md:text-xxs lg:text-base"
                      >
                        Belum ada feedback dari Penerima Manfaat
                      </td>
                    ) : (
                      <>
                        <td className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                          <StarRating rating={rateQty} maxStars={1} />
                        </td>
                        <td className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                          <StarRating rating={rateTime} maxStars={1} />
                        </td>
                        <td className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                          <StarRating rating={rateQuality} maxStars={1} />
                        </td>
                        <td className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                          <StarRating rating={avg} maxStars={1} />
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
            <button
              className={`px-2 py-2 rounded ${
                currentPage === 1
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-gray-500 hover:text-black"
              }`}
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
            >
              <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
            </button>
            <div className="flex items-center">
              {pageNumbers.map((page, idx) => (
                <span
                  key={idx}
                  onClick={() =>
                    typeof page === "number" && setCurrentPage(page)
                  }
                  className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
                    currentPage === page
                      ? "text-black font-semibold"
                      : "text-gray-700"
                  } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
                >
                  {page}
                </span>
              ))}
            </div>
            <button
              className={`px-2 py-2 rounded ${
                currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-gray-500 hover:text-black"
              }`}
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
            >
              <span className="font-bold text-lg sm:text-2xl">{">"}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}